<template>
    <div class="home">
        <div class="banner">
            <Carousel :slides="banners"></Carousel>
        </div>

        <div class="module series">
            <ModuleTitle class="page-title" :caption="service.title | pageTitle" :text="service.description"></ModuleTitle>
            <Steps v-for="(item, index) in service.list" :key="index" :service="item"></Steps>
        </div>

        <ModuleTitle :caption="service.help.title" :text="service.help.subTitle" :module="service.help" v-if="service.help" class="help">
            <template v-slot:default="{module}">
                <div class="module-btn">
                    <a :href="module.btn.to" onclick="return false">
                        <b-button class="btn dark" @click="redirect(module.btn.to)">{{module.btn.text}}</b-button>
                    </a>
                </div>
            </template>
        </ModuleTitle>
    </div>
</template>

<script>
    import ModuleTitle from '../components/common/ModuleTitle'
    import Carousel from '../components/common/Carousel'
    import Steps from '../components/container/service/Steps'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'service',
        components: {
            Carousel,
            ModuleTitle,
            Steps,
        },
        computed: {
            ...mapState('service', {
                banners: ({banners}) => {
                    return banners.map((banner, index) => {
                        return {
                            isPic: banner.type === 'pic',
                            isVideo: banner.type === 'video',
                            video: {
                                ref: 'allSeries' + index,
                                videoSrc: banner.src_file,
                                loop: true,
                                muted: true,
                                autoplay: true,
                            },
                            imgSrc: banner.src_file,
                            width: 1680,
                            height: 600,
                        }
                    })
                },
                service: ({service}) => {
                    let list = []

                    if (service.tailcare) {
                        list.push(
                            {
                                caption: service.tailcare.title,
                                desc: service.tailcare.description,
                                items: service.tailcare.steps.map(item => {
                                    return {
                                        imgSrc: item.pic_url,
                                        name: item.text,
                                    }
                                }),
                            })

                        // list[0].items.push(list[0].items[0])
                        // list[0].items.push(list[0].items[0])
                        // list[0].items.push(list[0].items[0])
                        // list[0].items.push(list[0].items[0])
                        // list[0].items.push(list[0].items[0])
                    }

                    return {
                        //title: service.service && service.service.title,
                        title: service.service && service.service.description,
                        description: service.service && service.service.description,
                        list: list,
                        help: {
                            title: '',
                            subTitle: service.tailcare && service.tailcare.need_help_text,
                            btn: {
                                text: service.tailcare && service.tailcare.contact_us_btn_text,
                                to: service.tailcare && service.tailcare.contact_us_btn_link,
                            }
                        }
                    }
                },

            })
        },
        methods: {
            ...mapActions('service', ['getPageInfo']),
            redirect(path) {
                this.$router.push({
                    path,
                })
                document.scrollingElement.scrollTop = 0
            },
        },
        created() {
            this.getPageInfo()
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .en {
        .help {
            .btn {
                line-height: 1 !important;
            }
        }
    }

    .series {
        > .title {
            padding-bottom: 0;
        }
    }

    .help {
        text-align: center;

        /deep/ .module-sub-title {
            font-size: 18px !important;
        }

        /deep/ .btn {
            margin-top: 50px;
            font-size: 18px;
            line-height: 35px;
        }
    }
</style>
